'use strict';

var dotenv = require('dotenv');
dotenv.load();

const config = {
  SendGridAPIKey: process.env.SENDGRID_API_KEY,
};

module.export = config;